// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1yqM2","consentsList":"PatientConsents_consentsList__rZ4hw","consentsListEmpty":"PatientConsents_consentsListEmpty__20qkd"};